<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="subjectGroups"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { SubjectGroup, Teaching } from '@/plugins/api'
import { mapState } from 'vuex'
import { uniqBy, sortBy, get } from 'lodash'

export default {
  data: () => ({
    subjectGroups: [],
    loading: false
  }),
  props: {
    filter: Object,
    defaultSubjectGroups: Array,
    options: Object
  },
  computed: {
    ...mapState('auth', ['role', 'profile'])
  },
  async created() {
    await this.initData()
  },
  methods: {
    async initData() {
      if (this.defaultSubjectGroups) {
        this.subjectGroups = this.defaultSubjectGroups
      }
      if (this.role.type === 'teacher') {
        const teachings = await Teaching.fetch({ teacher: this.profile.id, _limit: -1 })
        let subjectGroups = sortBy(
          uniqBy(
            teachings.map(x => x.subjectGroup),
            x => x.id
          ),
          x => x.index
        )
        if (get(this.options, 'hideInSecondary')) {
          subjectGroups = subjectGroups.filter(s => !get(s, 'hideInSecondary'))
        }
        this.subjectGroups = subjectGroups
      } else this.fetchAllSubjectGroups()
    },
    async fetchAllSubjectGroups() {
      this.loading = true
      const fetchParams = { ...this.filter, _limit: -1, _sort: 'index:ASC' }
      if (get(this.options, 'hideInSecondary')) fetchParams['hideInSecondary'] = false
      this.subjectGroups = await SubjectGroup.fetchRaw(fetchParams)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter() {
      this.fetchAllSubjectGroups()
    },
    'options.hideInSecondary': {
      async handler(val) {
        if (val) await this.initData()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
